import { LoadingButton } from "@mui/lab";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
} from "@mui/material";


export default function TodoDeleteDialog({ isOpen, closeDialog, deleteTodo, isSubmitting}) {

  return (
    <Dialog open={isOpen} onClose={closeDialog} fullWidth maxWidth="xs">
      <DialogTitle sx={{ mb: 2 }}>
        투두를 삭제할까요?
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          삭제한 후에는 복구할 수 없습니다.
        </DialogContentText>
        <DialogContentText>
          삭제한 투두는 수정내역에서 확인할 수 있습니다.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          size="large"
          sx={{ px: 6 }}
          loading={isSubmitting}
          onClick={closeDialog}
        >
          취소
        </LoadingButton>
        <LoadingButton
          size="large"
          sx={{ px: 6 }}
          loading={isSubmitting}
          variant="contained"
          onClick={deleteTodo}
        >
          삭제하기
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}